import t from "@/lang/lang";
import { TimeNumberInput } from "@/shared/components/inputs/time-number-input";
import { useQpmMonitorTimesMutation } from "@/services/backend/qpm/monitors/api/monitor-api";
import { Label } from "@/shared/components/ui/label";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shared/components/ui/tooltip";

const tooltipContentClassName =
  "bg-background text-foreground max-w-sm border text-left text-xs [&>svg]:bg-background [&>svg]:fill-background";

export function MonitorTimesComponent({
  monitorId,
  installSeconds,
  maintainSeconds,
  disabled,
}: {
  monitorId: string;
  installSeconds: number;
  maintainSeconds: number;
  disabled?: boolean;
}) {
  const [update] = useQpmMonitorTimesMutation();
  const timeHint = t(
    "Diese Zeiten werden in der Bestandsaufnahme verwendet und nicht für die Kalkulationszeiten.",
  );

  const installNs = installSeconds * 1_000_000_000;
  const maintainNs = maintainSeconds * 1_000_000_000;

  return (
    <div className="space-y-2">
      <div className="grid gap-1.5 sm:grid-cols-4">
        <div className="flex items-center gap-2 sm:col-span-2">
          <Label>{t("Installationszeit")}</Label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <button
                  type="button"
                  className="text-muted-foreground hover:text-foreground"
                  aria-label={t("Hinweis zu Servicezeiten")}
                >
                  <Info className="h-4 w-4" />
                </button>
              </TooltipTrigger>
              <TooltipContent className={tooltipContentClassName}>
                <p>{timeHint}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <div className="min-w-0 sm:col-span-2">
          <TimeNumberInput
            value={installNs}
            disabled={disabled}
            onChange={(value) =>
              update({
                id: monitorId,
                installSeconds: Math.round(value / 1_000_000_000),
                maintainSeconds,
              })
            }
          />
        </div>
      </div>

      <div className="grid gap-1.5 sm:grid-cols-4">
        <div className="flex items-center gap-2 sm:col-span-2">
          <Label>{t("Servicezeit")}</Label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <button
                  type="button"
                  className="text-muted-foreground hover:text-foreground"
                  aria-label={t("Hinweis zu Servicezeiten")}
                >
                  <Info className="h-4 w-4" />
                </button>
              </TooltipTrigger>
              <TooltipContent className={tooltipContentClassName}>
                <p>{timeHint}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <div className="min-w-0 sm:col-span-2">
          <TimeNumberInput
            value={maintainNs}
            disabled={disabled}
            onChange={(value) =>
              update({
                id: monitorId,
                installSeconds,
                maintainSeconds: Math.round(value / 1_000_000_000),
              })
            }
          />
        </div>
      </div>
    </div>
  );
}
